// @flow
import React from "react";
import SingleEntry from "../../../svg/facilities/single_entry.svg";
import "./singleEntryIcon.scss";

const SingleEntryIcon = () => <SingleEntry className="c-single-entry-icon" />;

export default SingleEntryIcon;
